import styled from 'styled-components';

import { modularScale } from '../../utils';
import { palette, fadeIn } from '../../theme';

export const DropdownMenu = styled.div`
  background: ${palette.brand.white};
  z-index: 100;
  max-height: 200px;
  white-space: nowrap;
  border-radius: ${modularScale(-2)};
  animation-duration: 0.2s;
  animation-name: ${fadeIn};
  animation-timing-function: ease;
  box-shadow: 1px 1px 10px rgba(0, 0, 0, 0.1);
  overflow-y: auto;
`;
